// import moment from "moment";
// import saveAs from "file-saver";
// import _ from "lodash";
// import { ExportExcelColor } from "../../../../../root/theme/exportColor";
// import { convertDateTimeFormat } from "../../../../../utils/ConvertDateTimeFormat";

// const excelRawChangeColor = (data: any, index: number, bodyLength: number) => {
//   if (data.Method === "Total Payments") {
//     return {
//       argb: ExportExcelColor.green,
//     };
//   } else {
//     if (index % 2 === 0) {
//       return {
//         argb: [ExportExcelColor.OddRowColor],
//       };
//     } else {
//       return {
//         argb: [ExportExcelColor.EvenRowColor],
//       };
//     }
//   }
// };

// /* Create a excel file */
// export const handleDownloadCsv = (
//   excelHeaders: any,
//   nodes: any,
//   filterDetails: any,
//   bodyLength: any,
// ) => {
//   const ExcelJS = require("exceljs");
//   const workbook = new ExcelJS.Workbook();
//   let excelHeader: any = {};

//   const worksheet = workbook.addWorksheet("Payment");

//   /* Worksheet add headers */
//   worksheet.columns = excelHeaders;

//   /* Find the last character in the excel */
//   const len = excelHeaders.length + 64;
//   let char = String.fromCharCode(len);

//   /* Add a title */
//   worksheet.getCell("A1").value = "Reward choices report";

//   worksheet.mergeCells(`B1:${char}1`);

//   const splitFilter = filterDetails.split("*");
//   let filterOptions = "";

//   /* Change of sub-title according to the number of locations.
//   If the location is one, then that location is displayed,
//   if more than one location, the number of locations is displayed. */
//   if (splitFilter[0].split(",").length === 1) {
//     filterOptions =
//       "Reward Choices Report for " +
//       splitFilter[0].split(",")[0] +
//       " " +
//       "Generated for the period of " +
//       splitFilter[1];
//   } else {
//     filterOptions =
//       "Reward Choices Report for " +
//       splitFilter[0].split(",").length +
//       " Locations " +
//       "Generated for the period of " +
//       splitFilter[1];
//   }

//   /* Add sub-title using filter options. */
//   worksheet.getCell("B1").value = filterOptions;

//   /* Add a empty row. */
//   worksheet.addRow({});

//   /* Add a headers and change the header and empty row height. */
//   excelHeaders.map((data: any) => {
//     excelHeader[data.key] = data.header;
//   });
//   worksheet.addRow(excelHeader);
//   worksheet.getRow(1).height = 28;
//   worksheet.getRow(2).height = 28;

//   /* Add a body in the excel. */
//   nodes.map((data: any, index: number) => {
//    const excelData: any = {};

//   Object.keys(excelHeader).map((header: any, colIndex: number) => {
//     let value = data[header];

//     // ✅ Convert only first (index 0) and second (index 1) columns to date-time
//     // Skip header (handled above) and skip last row (footer)
//     if (colIndex === 0 || colIndex === 1) {
//       const isLastRow = index === nodes.length - 1;
//       if (!isLastRow && value) {
//         // Convert ISO string → formatted datetime
//         value = convertDateTimeFormat(value);
//       }
//     }

//     excelData[header] = value;
//   });
//     worksheet.addRow(excelData);

//     // Change the alignment in the cell.
//     const row = worksheet.getRow(index + 3);
//     row.eachCell({ includeEmpty: true }, function (cell: any, colNumber: any) {
//       let char = String.fromCharCode(64 + colNumber);
//       worksheet.getCell(`B${index + 3})`).alignment = {
//         vertical: "bottom",
//         horizontal: "center",
//       };
//       worksheet.getCell(`C${index + 3})`).alignment = {
//         vertical: "bottom",
//         horizontal: "center",
//       };
//       worksheet.getCell(`D${index + 3})`).alignment = {
//         vertical: "bottom",
//         horizontal: "center",
//       };
//       worksheet.getCell(`E${index + 3})`).alignment = {
//         vertical: "bottom",
//         horizontal: "center",
//       };
//       worksheet.getCell(`F${index + 3})`).alignment = {
//         vertical: "bottom",
//         horizontal: "center",
//       };
//       worksheet.getCell(`G${index + 3})`).alignment = {
//         vertical: "bottom",
//         horizontal: "right",
//       };

//       // Change the font style in the specific cell.
//       if (colNumber === 1) {
//         worksheet.getCell(`${char}${index + 3})`).font = { bold: true };
//       }
//     });

//     worksheet.getRow(index + 3).height = 28;
//   });

//   /* Change the footer color and styles */
//   const row = worksheet.getRow(nodes.length + 3);
//   row.eachCell({ includeEmpty: true }, function (cell: any, colNumber: any) {
//     let char = String.fromCharCode(64 + colNumber);
//     worksheet.getCell(`C${nodes.length + 3})`).alignment = {
//       vertical: "bottom",
//       horizontal: "center",
//     };
//     worksheet.getCell(`D${nodes.length + 3})`).alignment = {
//       vertical: "bottom",
//       horizontal: "center",
//     };
//     worksheet.getCell(`E${nodes.length + 3})`).alignment = {
//       vertical: "bottom",
//       horizontal: "center",
//     };
//     worksheet.getCell(`F${nodes.length + 3})`).alignment = {
//       vertical: "bottom",
//       horizontal: "center",
//     };
//     worksheet.getCell(`G${nodes.length + 3})`).alignment = {
//       vertical: "bottom",
//       horizontal: "right",
//     };
//     worksheet.getCell(`${char}${nodes.length + 3})`).font = { bold: true };
//   });

//   /* Change the footer height */
//   worksheet.getRow(nodes.length + 3).height = 28;

//   /* Change the font color in the all cells */
//   worksheet.addConditionalFormatting({
//     ref: `A4:${char}${nodes.length + 2}`,
//     rules: [
//       {
//         type: "expression",
//         formulae: ["MOD(2,2)=0"],
//         style: {
//           fill: {
//             type: "pattern",
//             pattern: "solid",
//           },
//           font: { color: { argb: "FFFFFF" } },
//         },
//       },
//     ],
//   });

//   /* Change the title style */
//   worksheet.addConditionalFormatting({
//     ref: "A1",
//     rules: [
//       {
//         type: "expression",
//         formulae: ["MOD(2,2)=0"],
//         style: {
//           fill: {
//             type: "pattern",
//             pattern: "solid",
//           },
//           font: { bold: true, size: 10 },
//         },
//       },
//     ],
//   });

//   /* Change the sub title stile */
//   worksheet.addConditionalFormatting({
//     ref: `B1:${char}1`,
//     rules: [
//       {
//         type: "expression",
//         formulae: ["MOD(2,2)=0"],
//         style: {
//           fill: {
//             type: "pattern",
//             pattern: "solid",
//           },
//           font: {
//             bold: true,
//             size: 10,
//           },
//         },
//       },
//     ],
//   });

//   /* Change all row colors. */
//   nodes.map((data: any, index: any) => {
//     if (index + 1 !== nodes.length) {
//       worksheet.addConditionalFormatting({
//         ref: `A${index + 4}:${char}${index + 4}`,
//         rules: [
//           {
//             type: "expression",
//             formulae: ["MOD(2,2)=0"],
//             style: {
//               fill: {
//                 type: "pattern",
//                 pattern: "solid",
//                 bgColor: excelRawChangeColor(data, index, bodyLength),
//               },
//               font: { color: { argb: "000000" } },
//             },
//           },
//         ],
//       });
//     }
//   });

//   /* Bold the letters in the first column. */
//   const column = worksheet.getColumn(1);
//   column.style = { font: { bold: true } };

//   /* Change the header row color */
//   worksheet.addConditionalFormatting({
//     ref: `A3:${char}3`,
//     rules: [
//       {
//         type: "expression",
//         formulae: ["MOD(2,2)=0"],
//         style: {
//           fill: {
//             type: "pattern",
//             pattern: "solid",
//             bgColor: { argb: ExportExcelColor.HeaderRowColor },
//           },
//           font: {
//             bold: true,
//             color: { argb: "ffffff" },
//           },
//         },
//       },
//     ],
//   });

//   /* Change the footer row color */
//   worksheet.addConditionalFormatting({
//     ref: `A${nodes.length + 3}:${char}${nodes.length + 3}`,
//     rules: [
//       {
//         type: "expression",
//         formulae: ["MOD(2,2)=0"],
//         style: {
//           fill: {
//             type: "pattern",
//             pattern: "solid",
//             bgColor: { argb: ExportExcelColor.green },
//           },
//           font: {
//             bold: true,
//             color: { argb: "ffffff" },
//           },
//         },
//       },
//     ],
//   });

//   const today = moment().format("MMM_Do_YY").toString();
//   workbook.xlsx.writeBuffer().then(function (buffer: any) {
//     saveAs(
//       new Blob([buffer], { type: "application/octet-stream" }),
//       `Reward_Choices_${today}_${Math.floor(
//         100000 + Math.random() * 900000,
//       )}.xlsx`,
//     );
//   });
// };

import moment from "moment";
import saveAs from "file-saver";
import _ from "lodash";
import { ExportExcelColor } from "../../../../../root/theme/exportColor";
import { convertDateTimeFormat } from "../../../../../utils/ConvertDateTimeFormat";

// A helper function to apply common row styling (fill, font, height)
// ✅ UPDATED: Now accepts colCount to style cells individually
const styleRow = (
  row: any,
  style: { fill?: any; font?: any },
  colCount: number, // Pass in the number of columns
) => {
  row.height = 28; // Set a consistent row height

  // Iterate from 1 (inclusive) to colCount (inclusive)
  for (let i = 1; i <= colCount; i++) {
    const cell = row.getCell(i);
    if (style.fill) {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: style.fill,
      };
    }
    if (style.font) {
      cell.font = style.font;
    }
  }
};

// A helper function to apply cell alignments for a row
const applyAlignments = (row: any, colCount: number) => {
  row.eachCell({ includeEmpty: true }, (cell: any, colNumber: number) => {
    // Only apply to cells within our defined column count
    if (colNumber > colCount) return;

    // Default to center
    cell.alignment = { vertical: "middle", horizontal: "center" };

    if (colNumber === 1) {
      // First column: left-aligned and bold
      cell.alignment = { vertical: "middle", horizontal: "left" };
      cell.font = { ...cell.font, bold: true };
    } else if (colNumber === colCount) {
      // Last column: right-aligned
      cell.alignment = { vertical: "middle", horizontal: "right" };
    }
  });
};

/**
 * Create an Excel file with multiple tables
 *
 * @param excelHeaders - Array of column definitions, e.g., [{ key: 'dataKey', header: 'Column Name', width: 20 }]
 * @param nodes - An object where each key holds data for a table, e.g., { key: { name: 'Table Title', body: [], footer: {} }}
 * @param filterDetails - A string containing filter info, separated by "*"
 */
export const handleDownloadCsv = (
  excelHeaders: any[],
  nodes: Record<string, any>,
  filterDetails: string,
) => {
  const ExcelJS = require("exceljs");
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Reward Choices Report");

  // This is now the single source of truth for column count
  const colCount = excelHeaders.length;

  /* 1. Set column properties (keys and widths) */
  worksheet.columns = excelHeaders.map((h) => ({
    key: h.key,
    width: h.width || 25, // Default width if not specified
  }));

  /* 2. Add Main Report Title */
  const titleCell = worksheet.getCell("A1");
  titleCell.value = "Reward choices report";
  titleCell.font = { bold: true, size: 14 };
  titleCell.alignment = { horizontal: "left" };
  worksheet.getRow(1).height = 28;
  if (colCount > 1) {
    worksheet.mergeCells(1, 1, 1, colCount); // Merge title row
  }

  /* 3. Add Sub-title (Filter Details) */
  const splitFilter = filterDetails.split("*");
  let filterOptions = "";
  const locationFilter = splitFilter[0] || "";
  const periodFilter = splitFilter[1] || "";

  if (locationFilter.split(",").length === 1) {
    filterOptions =
      `Reward Choices Report for ${locationFilter} ` +
      `Generated for the period of ${periodFilter}`;
  } else {
    filterOptions =
      `Reward Choices Report for ${
        locationFilter.split(",").length
      } Locations ` + `Generated for the period of ${periodFilter}`;
  }

  const subTitleCell = worksheet.getCell("A2");
  subTitleCell.value = filterOptions;
  subTitleCell.font = { bold: true, size: 10 };
  subTitleCell.alignment = { horizontal: "left" };
  worksheet.getRow(2).height = 28;
  if (colCount > 1) {
    worksheet.mergeCells(2, 1, 2, colCount); // Merge subtitle row
  }

  /* 4. Helper arrays for data mapping */
  const headerKeys = excelHeaders.map((h: any) => h.key);
  const headerNames = excelHeaders.map((h: any) => h.header);

  let currentRow = 3; // Start after titles

  /* 5. Iterate over each table in the nodes object */
  Object.entries(nodes).forEach(([key, value]: [string, any]) => {
    if (_.isEmpty(value) || !value.body) return; // Skip if no data

    // Add a spacer row
    worksheet.addRow([]);
    currentRow++;

    // Add Table Title
    const tableTitleRow = worksheet.addRow([value.name]);
    currentRow++;
    const tableSubTitleRow = worksheet.addRow([
      "Note: This report is generated for the selected location only, as reward item selections may differ across locations.",
    ]);
    currentRow++;
    if (colCount > 1) {
      worksheet.mergeCells(currentRow, 1, currentRow, colCount);
    }
    tableTitleRow.font = { bold: true, size: 12 };
    tableTitleRow.getCell(1).alignment = { horizontal: "left" };

    tableSubTitleRow.getCell(1).alignment = { horizontal: "left" };

    // Add Table Header Row
    const headerRow = worksheet.addRow(headerNames);
    currentRow++;
    // ✅ UPDATED: Pass colCount
    styleRow(
      headerRow,
      {
        fill: { argb: ExportExcelColor.HeaderRowColor },
        font: { bold: true, color: { argb: "FFFFFF" } },
      },
      colCount,
    );
    // Align headers
    headerRow.eachCell((cell: any, colNumber: number) => {
      if (colNumber > colCount) return; // Don't style extra cells
      cell.alignment = { vertical: "middle", horizontal: "center" };
      if (colNumber === 1) {
        cell.alignment.horizontal = "left";
      } else if (colNumber === colCount) {
        cell.alignment.horizontal = "right";
      }
    });

    // Add Body Rows
    value.body.forEach((data: any, index: number) => {
      const excelData = headerKeys.map(
        (headerKey: string, colIndex: number) => {
          let cellValue = data[headerKey];
          // Format date/time for first two columns
          // if (colIndex === 0 || colIndex === 1) {
          //   if (cellValue) {
          //     cellValue = convertDateTimeFormat(cellValue);
          //   }
          // }
          return cellValue;
        },
      );

      const bodyRow = worksheet.addRow(excelData);
      currentRow++;

      // Apply alternating row color
      const color =
        index % 2 === 0
          ? ExportExcelColor.OddRowColor
          : ExportExcelColor.EvenRowColor;

      // ✅ UPDATED: Pass colCount
      styleRow(
        bodyRow,
        {
          fill: { argb: color },
          font: { color: { argb: "FFFFFF" } }, // White text, as per new PDF style
        },
        colCount,
      );

      // Apply alignments
      applyAlignments(bodyRow, colCount);
    });

    // Add Footer Row
    if (value.footer) {
      const footerData = headerKeys.map(
        (headerKey: string) => value.footer[headerKey],
      );
      const footerRow = worksheet.addRow(footerData);
      currentRow++;

      // ✅ UPDATED: Pass colCount
      styleRow(
        footerRow,
        {
          fill: { argb: ExportExcelColor.green },
          font: { bold: true, color: { argb: "FFFFFF" } },
        },
        colCount,
      );

      // Apply alignments (first col will be bolded by the helper)
      applyAlignments(footerRow, colCount);
    }
  });

  /* 6. Save the file */
  const today = moment().format("MMM_Do_YY").toString();
  workbook.xlsx.writeBuffer().then(function (buffer: any) {
    saveAs(
      new Blob([buffer], { type: "application/octet-stream" }),
      `Reward_Choices_${today}_${Math.floor(
        100000 + Math.random() * 900000,
      )}.xlsx`,
    );
  });
};
